// src/components/ui/Card.tsx
import * as React from 'react'
import { cn } from '../../lib/utils'

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'rounded-2xl border border-gray-200 bg-white shadow-sm p-4 dark:border-gray-800 dark:bg-gray-900',
      className
    )}
    {...props}
  />
))

Card.displayName = 'Card'
